import updateCategory from '../orchestrators/updateCategory';
import { OptionCategory } from 'owa-options-core';
/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */

export default orchestratorAction('selectCategory', async function selectCategory(
    category: OptionCategory
): Promise<void> {
    const currentSubCategoryKey =
        category.subcategories && category.subcategories[0] && category.subcategories[0].key;
    updateCategory(category.key, currentSubCategoryKey, null);
});
